/*! @azure/msal-common v7.1.0 2022-07-05 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "7.1.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
